module.exports = __webpack_public_path__ + "e3444c47c8dca75cea1fa655a68545bb.svg";